import { fetch } from '../utils/fetch'
/*
    API:    GET
    NAME:   获取数据
*/
export function getDashboardInfo(data) {
  return fetch({
    url: 'workbench/queryDateCount',
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取收入数据统计
*/
export function getDashboardIncomeExpense(data) {
  return fetch({
    url: 'workbench/queryIncomeCount',
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取支出数据统计
*/
export function getDashboardExpense(data) {
  return fetch({
    url: 'workbench/queryExpenseCount',
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取利润数据统计
*/
export function getDashboardProfit(data) {
  return fetch({
    url: 'workbench/queryProfitCount',
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取部门收入占比统计
*/
export function getDashboardRate(data) {
  return fetch({
    url: 'workbench/queryDepartmentCount',
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取部门收入占比统计
*/
export function getDepartmentRevenueProgress(data) {
  return fetch({
    url: 'workbench/queryDepartmentRevenueProgress',
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取逾期合同
*/
export function getOverdueContract(data) {
  return fetch({
    url: 'workbench/queryOverdueContract',
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取逾期合同
*/
export function getYuqueDoc() {
  return fetch({
    url: 'yuque/queryDocList',
    method: 'get'
  })
}
